import React, { useEffect } from 'react';
import { useImmer } from 'use-immer';
import _ from 'lodash';
import { Button, Row, Col } from 'shards-react';
import { useMediaQuery } from 'react-responsive';
import MetaTags from 'react-meta-tags';

import images from '../../images/images';
import { TopScrollContainer, RoomPopUp } from '../../components/custom-list/index';
import useRouter from '../../hooks/use-router';
import useClub from '../../api/club-service';

const HsinchuHall = () => {

  const { push } = useRouter();

  const { getClubDetail } = useClub();

  const isMobile = useMediaQuery({ query: '(max-width: 992px)' });

  const [state, produce] = useImmer({
    ...location.state,
    tabSelect: 0,
    detail: null,

    name: null,
    title: null,
    shortTitle: null,
    metaTitle: null,
    metaDescription: null,
    keywords: null,

    summary: null,
    telephone: null,
    address: null,
    parking: null,
    mapUrl: null,
    blocks: [],
    houses: [],
  });

  const { tabSelect, detail, name, title, shortTitle, metaTitle, metaDescription, keywords, summary, telephone, address, parking, mapUrl, blocks, houses } = state;

  const HsinchuConnectionDatas = [
    {
      title: `電${'\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0'}話`,
      content: state.telephone ?? "",
    },
    {
      title: `地${'\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0'}址`,
      content: state.address ?? "",
    },
    {
      title: '停車資訊',
      content: state.parking ?? "",
    },
  ];

  const CustomImg = ({ width, imgSrc, style }) => (
    <img
      loading="lazy"
      src={imgSrc}
      style={{
        marginBottom: isMobile && 15,
        width: isMobile ? 'calc(100% - 20px)' : width,
        marginLeft: isMobile ? 25 : 15,
        height: 'fit-content',
        objectFit: 'cover',
        borderRadius: 6,
        ...style,
      }}
    />
  );

  const CustomSpan = ({ title, content, key }) => (
    <div style={{ display: 'flex' }} key={key}>
      <span style={{ fontSize: 16, whiteSpace: 'nowrap', color: '#5E5E5E', fontWeight: 400 }}>{title}</span>
      <span style={{ marginLeft: 10, marginBottom: 15, fontSize: 16, color: '#5E5E5E', fontWeight: 400 }}>{content}</span>
    </div>
  );


  useEffect(() => {
    getDetail(3);
  }, []);

  const getDetail = async (id) => {
    if (!!detail) return;
    produce((draft) => void (draft.loading = true));
    const { status, message, result } = await getClubDetail(id);
    produce((draft) => void (draft.loading = false));
    if (status == '1') {
      produce((draft) => {
        draft.name = result.name
        draft.summary = result.summary
        draft.telephone = result.telephone
        draft.address = result.address
        draft.parking = result.parking
        draft.mapUrl = result.mapUrl
        draft.blocks = result.blocks
        draft.houses = result.houses

        draft.title = result.title
        draft.shortTitle = result.shortTitle
        draft.metaTitle = result.metaTitle
        draft.metaDescription = result.metaDescription
        draft.keywords = result.keywords
      });
    } else {
      push('/');
    }
  };

  const getImage = (isMobile, data, index) => {
    let image = data[`image${index}`];
    let mobile = data[`imageMobile${index}`];

    if (isMobile) {

      return mobile || image;
    }

    return image;
  }

  return (
    <TopScrollContainer
      breadcrumb={[{ title: '首頁', to: '/' }, { title: '新竹' }]}
      titleBackground={images.top_05_a}
      background={images.background_08_a}
      title={isMobile ? state.shortTitle : state.title}
      titleTab={['公共區域', '房型介紹', '聯絡方式']}
      // titleBtn={tabSelect == 0 ? ['遊戲區', '嬰兒室', '媽媽空間', '接待大廳', '諮詢室'] : null}
      handleChange={(index) => produce((draft) => void (draft.tabSelect = index))}
    // isShowBtnMobile={true}
    // isShowLineMobile={true}
    >
      <MetaTags>
        <title>{state.metaTitle}</title>
        <meta name="description" content={state.metaDescription} />
        <meta
          name="keywords"
          content={state.keywords}
        />
      </MetaTags>
      {tabSelect == 0 && (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            {_.map(state.blocks, (data, index) => (
              <div key={index}>
                {index == 0 && !isMobile && (
                  <div style={{ textAlign: 'center' }}>
                    <span style={{ fontWeight: 400 }}>{state.summary}</span>
                  </div>
                )}

                {data?.type !== 3 && index != 0 && (
                  <Row
                    style={{
                      background: '#C5C1BA',
                      height: 1,
                      marginRight: 0,
                    }}
                  />
                )}

                {data?.type !== 3 && (<Row
                  id={`item${index}`}
                  className={index == 0 && isMobile ? '' : isMobile ? 'mt-4' : 'mt-4 mb-4'}
                  style={{ width: '100%', flex: 1, flexDirection: index % 2 == 1 ? 'row-reverse' : 'row' }}
                >
                  {
                    <div style={
                      {
                        width: data?.type === 2 || data?.type === 4 ? (isMobile ? '100%' : '30%') : isMobile ? 'calc(100% - 20px)' : '65%',
                        height: isMobile ? 260 : 'fit-content',
                        marginLeft: isMobile ? 25 : 15,
                        objectFit: 'cover',
                        borderRadius: 6,
                        marginBottom: isMobile ? 20 : '',
                      }
                    }>
                      <img
                        loading="lazy"
                        src={`${process.env.REACT_APP_SERVER_HOST}${getImage(isMobile, data, 1)}`}
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                          borderRadius: 6,
                        }}
                      />
                    </div>
                  }
                  {data?.type === 4 && (
                    <div style={
                      {
                        width: isMobile ? '100%' : '30%',
                        height: 'fit-content',
                        marginLeft: isMobile ? 25 : 15,
                        marginBottom: isMobile ? 20 : '',
                      }
                    }>
                      <img
                        loading="lazy"
                        src={`${process.env.REACT_APP_SERVER_HOST}${getImage(isMobile, data, 2)}`}
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                          borderRadius: 6,
                        }}
                      />
                    </div>
                  )}
                  <Col className="ml-2">
                    <h4>{data.title}</h4>
                    <ul style={{ marginLeft: -15 }}>
                      {_.map(data.items, (item, index) => (
                        <li
                          key={index}
                          style={{
                            fontSize: 16,
                            color: '#5E5E5E',
                            textAlign: 'justify',
                            fontWeight: 400,
                            marginBottom: 15,
                            listStyleImage: `url(${images.tree_icon})`,
                          }}
                        >
                          {item}
                        </li>
                      ))}
                    </ul>
                  </Col>
                </Row>)}

                {data?.type === 3 && (
                  <Row
                    className={index == 0 && isMobile ? '' : isMobile ? '' : 'mb-4'}
                    style={{ width: '100%', flex: 1 }}>
                    <div style={
                      {
                        width: isMobile ? 'calc(100% - 20px)' : `${200 / 3}%`,
                        paddingLeft: isMobile ? '' : 15,
                        marginLeft: isMobile ? 25 : '',
                        height: isMobile ? 260 : 'fit-content',
                        objectFit: 'cover',
                        borderRadius: 6,
                        marginBottom: isMobile ? 20 : '',
                      }
                    }>
                      <img
                        loading="lazy"
                        src={`${process.env.REACT_APP_SERVER_HOST}${getImage(isMobile, data, 1)}`}
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                          borderRadius: 6,
                        }}
                      />
                    </div>

                    <div style={
                      {
                        width: isMobile ? 'calc(100% - 20px)' : `${100 / 3}%`,
                        paddingLeft: isMobile ? '' : 30,
                        marginLeft: isMobile ? 25 : '',
                        height: isMobile ? 260 : '',
                        objectFit: 'cover',
                        borderRadius: 6,
                        marginBottom: isMobile ? 20 : '',
                      }
                    }>
                      <img
                        loading="lazy"
                        src={`${process.env.REACT_APP_SERVER_HOST}${getImage(isMobile, data, 2)}`}
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                          borderRadius: 6,
                        }}
                      />
                    </div>

                  </Row>
                )}

              </div>
            ))}
          </div>
        </div>
      )}
      {tabSelect == 1 && (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            {_.map(state.houses, (data, index) => (
              <div key={index}>
                <Row id={`item${index}`} className={index == 0 && isMobile ? '' : isMobile ? "mt-4" : "my-4"} style={{ width: '100%', flex: 1 }}>
                  <CustomImg imgSrc={`${process.env.REACT_APP_SERVER_HOST}${data.image}`} width={'65%'} />
                  <Col className="ml-2" style={{ alignSelf: 'center' }}>
                    <h4>{data.title}</h4>

                    <div style={{ display: 'flex' }}>
                      <img className="mr-1 lazy" src={images.square_feet} height={22} width={22} />
                      <span style={{ display: 'flex', marginBottom: 10 }}>{data?.plain} 坪</span>
                    </div>

                    <span
                      style={{
                        fontSize: 16,
                        color: '#5E5E5E',
                        textAlign: 'justify',
                        fontWeight: 400,
                      }}
                    >
                      {data?.content}
                    </span>

                    <div style={{ display: 'flex', marginTop: 15, width: '100%', justifyContent: isMobile ? 'center' : '' }}>
                      <Button
                        theme="success"
                        className="my-1"
                        style={{
                          maxHeight: 42,
                          width: 100,
                          fontSize: 16,
                          marginRight: 15,
                          backgroundColor: 'rgba(82,181,79,1)',
                        }}
                        onClick={() => produce((draft) => void (draft.detail = data))}
                      >
                        查看詳細
                      </Button>
                      <Button
                        theme="success"
                        className="my-1"
                        style={{
                          maxHeight: 42,
                          width: 100,
                          fontSize: 16,
                          backgroundColor: 'transparent',
                          color: 'rgba(82,181,79,1)',
                        }}
                        onClick={() => window.open(data?.link, '_blank')}
                      >
                        環景預覽
                      </Button>
                    </div>
                  </Col>
                </Row>

                {index != state.houses.length - 1 && (
                  <Row
                    style={{
                      marginTop: 19,
                      background: '#C5C1BA',
                      height: 1,
                      marginRight: 0,
                    }}
                  />
                )}
              </div>
            ))}
          </div>
        </div>
      )}
      {tabSelect == 2 && (
        <div
          style={{
            display: 'flex',
            flexDirection: isMobile ? 'column' : '',
            marginTop: 15,
            paddingLeft: isMobile ? 10 : '',
            paddingRight: isMobile ? 10 : '',
          }}
        >
          <div style={{ width: isMobile ? '100%' : '85%', height: isMobile ? 250 : '50vh', position: 'relative' }}>
            <iframe
              src={state.mapUrl}
              width="100%"
              height="100%"
              frameBorder="0"
              style={{ border: 0 }}
              allowFullScreen=""
              aria-hidden="false"
              tabIndex="0"
            />
          </div>
          <div style={{ marginLeft: isMobile ? '' : 30, marginTop: 20, width: isMobile ? '100%' : '40%' }}>
            <h2 style={{ fontSize: 24, color: '#5E5E5E', fontWeight: 500 }}>聯絡方式</h2>
            {_.map(HsinchuConnectionDatas, (item, index) => (
              <CustomSpan key={index} title={item.title} content={item.content} />
            ))}
          </div>
        </div>
      )}
      {detail && (
        <RoomPopUp
          isShowDialog={!!detail}
          overlayAction={() => {
            produce((draft) => void (draft.detail = null));
            push('/hsinchu-hall');
          }}
          detail={detail}
        />
      )}
    </TopScrollContainer>
  );
};

export default HsinchuHall;
